import { createStore } from "zustand-x";
import { router } from "../../routes/routes";
import { notifications } from "@mantine/notifications";
import { RouterNavigateOptions, To } from "react-router";
import { actions } from "../useStore";
import { uniqueId } from "lodash";
import { ICoreStoreInterface } from "../../models/interfaces/core/Core.interface";

const initialState: ICoreStoreInterface = {
  isApplicationRefreshing: false,
  data: {},
};

const coreStore = createStore<ICoreStoreInterface>(initialState, {
  name: "core",
}).extendActions((state, get, api) => ({
  route: (path: To, opts?: RouterNavigateOptions) => {
    // actions.filter.reset();
    actions.core.reset();
    router.navigate(path, opts);
  },
  // DEPRECATED
  forceUpdate: () => {
    // (get.data() as any)?.forceUpdate();
  },
  setApplicationRefresh: (status: boolean) => {
    state.isApplicationRefreshing(status);
  },
  throwError: (title: string, message?: string, id?: string) => {
    notifications.show({
      id: id ?? uniqueId(),
      color: "red",
      withBorder: true,
      title,
      message,
    });
  },
  notify: (title: string, message?: string) => {
    notifications.show({
      title,
      message,
    });
  },
  // Reset all stores using below method
  reset: () => {
    actions.filter.reset();
  },
}));

export default coreStore;
